export default __webpack_public_path__ + "static/media/mb12.313f3134.jpg";